import React, {Fragment} from 'react';
import q1_1 from '../images/Q1-1.jpg';
import q1_2 from '../images/Q1-2.jpg';
import q1_3 from '../images/Q1-3.jpg';
import q1_4 from '../images/Q1-4.jpg';
import q1_5 from '../images/Q1-5.jpg';
import q1_6 from '../images/Q1-6.jpg';
import q1_7 from '../images/Q1-7.jpg';
import q1_8 from '../images/Q1-8.jpg';
import q1_9 from '../images/Q1-9.jpg';
import q1_10 from '../images/Q1-10.jpg';
import q_0 from '../images/Q.jpg';
import q2_1 from '../images/Q2-1.jpg';
import q2_2 from '../images/Q2-2.jpg';
import q2_3 from '../images/Q2-3.jpg';
import q2_4 from '../images/Q2-4.jpg';
import q2_5 from '../images/Q2-5.jpg';
import q2_6 from '../images/Q2-6.JPG';
import q2_7 from '../images/Q2-7.jpg';
import q2_8 from '../images/Q2-8.jpg';
import q2_9 from '../images/Q2-9.JPG';
import q2_10 from '../images/Q2-10.jpg';
import q3_1 from '../images/Q3-1.jpg';
import q3_2 from '../images/Q3-2.jpg';
import q3_3 from '../images/Q3-3.jpeg';
import q3_4 from '../images/Q3-4.jpg';
import q3_5 from '../images/Q3-5.jpg';
import q3_6 from '../images/Q3-6.jpg';
import q3_7 from '../images/Q3-7.jpg';
import q3_8 from '../images/Q3-8.jpg';
import q3_9 from '../images/Q3-9.jpg';
import q3_10 from '../images/Q3-10.jpg';
import q4_1 from '../images/Q4-1.jpg';
import q4_2 from '../images/Q4-2.jpg';
import q4_3 from '../images/Q4-3.jpg';
import q4_4 from '../images/Q4-4.jpg';
import q4_5 from '../images/Q4-5.jpg';
import q4_6 from '../images/Q4-6.jpg';
import q4_7 from '../images/Q4-7.jpg';
import q4_8 from '../images/Q4-8.jpg';
import q4_9 from '../images/Q4-9.jpg';
import q4_10 from '../images/Q4-10.jpg';
import q5_1 from '../images/Q5-1.jpg';
import q5_2 from '../images/Q5-2.jpg';
import q5_3 from '../images/Q5-3.png';
import q5_4 from '../images/Q5-4.png';
import q5_5 from '../images/Q5-5.jpg';
import q5_6 from '../images/Q5-6.jpg';
import q5_7 from '../images/Q5-7.jpg';
import q5_8 from '../images/Q5-8.jpg';
import q5_9 from '../images/Q5-9.jpg';
import q5_10 from '../images/Q5-10.jpg';
import q6_1 from '../images/Q6-1.jpg';
import q6_2 from '../images/Q6-2.jpg';
import q6_3 from '../images/Q6-3.jpg';
import q6_4 from '../images/Q6-4.jpg';
import q6_5 from '../images/Q6-5.jpg';
import q6_6 from '../images/Q6-6.jpg';
import q6_7 from '../images/Q6-7.gif';
import q6_8 from '../images/Q6-8.jpg';
import q6_9 from '../images/Q6-9.jpg';
import q6_10 from '../images/Q6-10.jpg';
import q7_1 from '../images/Q7-1.jpg';
import q7_2 from '../images/Q7-2.png';
import q7_3 from '../images/Q7-3.jpg';
import q7_4 from '../images/Q7-4.jpg';
import q7_5 from '../images/Q7-5.jpg';
import q7_6 from '../images/Q7-6.jpg';
import q7_7 from '../images/Q7-7.jpg';
import q7_8 from '../images/Q7-8.jpg';
import q7_9 from '../images/Q7-9.jpg';
import q7_10 from '../images/Q7-10.jpeg';
import q8_1 from '../images/Q8-1.jpg';
import q8_2 from '../images/Q8-2.jpg';
import q8_3 from '../images/Q8-3.jpg';
import q8_4 from '../images/Q8-4.jpg';
import q8_5 from '../images/Q8-5.jpg';
import q8_6 from '../images/Q8-6.jpg';
import q8_7 from '../images/Q8-7.jpg';
import q8_8 from '../images/Q8-8.jpg';
import q8_9 from '../images/Q8-9.jpg';
import q8_10 from '../images/Q8-10.jpg';
import q9_1 from '../images/Q9-1.jpg';
import q9_2 from '../images/Q9-2.jpg';
import q9_3 from '../images/Q9-3.jpg';
import q9_4 from '../images/Q9-4.jpg';
import q9_5 from '../images/Q9-5.jpg';
import q9_6 from '../images/Q9-6.jpg';
import q9_7 from '../images/Q9-7.jpg';
import q9_8 from '../images/Q9-8.jpg';
import q9_9 from '../images/Q9-9.jpg';
import q9_10 from '../images/Q9-10.jpg';
import q10_1 from '../images/Q10-1.jpg';
import q10_2 from '../images/Q10-2.jpg';
import q10_3 from '../images/Q10-3.png';
import q10_4 from '../images/Q10-4.jpg';
import q10_5 from '../images/Q10-5.jpg';
import q10_6 from '../images/Q10-6.jpg';
import q10_7 from '../images/Q10-7.jpg';
import q10_8 from '../images/Q10-8.jpg';
import q10_9 from '../images/Q10-9.jpg';
import q10_10 from '../images/Q10-10.png';
import q11_1 from '../images/Q11-1.jpg';
import q11_2 from '../images/Q11-2.jpg';
import q11_3 from '../images/Q11-3.jpg';
import q11_4 from '../images/Q11-4.jpg';
import q11_5 from '../images/Q11-5.png';
import q11_6 from '../images/Q11-6.jpg';
import q11_7 from '../images/Q11-7.jpg';
import q11_8 from '../images/Q11-8.jpg';
import q11_9 from '../images/Q11-9.jpg';
import q11_10 from '../images/Q11-10.jpg';
import q12_1 from '../images/Q12-1.png';
import q12_2 from '../images/Q12-2.jpg';
import q12_3 from '../images/Q12-3.jpg';
import q12_4 from '../images/Q12-4.jpg';
import q12_5 from '../images/Q12-5.jpg';
import q12_6 from '../images/Q12-6.jpg';
import q12_7 from '../images/Q12-7.jpg';
import q12_8 from '../images/Q12-8.jpg';
import q12_9 from '../images/Q12-9.jpg';
import q12_10 from '../images/Q12-10.jpg';

export default [

    {
     name: '1',
     text: (<Fragment><div>International Physicians for the Prevention of Nuclear War, a Nobel Peace Prize winning organization, has called for the abolition of uranium mining worldwide. The primary reasons behind this call are:</div><div>  <ul><li> uranium mining leaves behind radioactive residues that will pose a health danger for hundreds of thousands of years. </li><li>  nuclear reactors fueled with uranium create the most biologically damaging industrial waste ever produced;  </li><li>  uranium is the key ingredient in nuclear weaponry that threatens the health and survival of all humanity; </li></ul>     Do you agree with this call?</div></Fragment>),
     latitude:42.427410, 
     longitude:-71.076198,
     images: [
       q1_1, q1_2, q1_3, q1_4, q1_5, q1_6, q1_7, q1_8, q1_9, q1_10
     ],
     yes: [
        'peacekeeping', 'ecological restoration', 'human survival', 'radwaste management'
     ],
     no: [
       'environmental degradation', 'global crisis', 'biological damage', 'human extinction', 'rising public health risk'
     ]
    },
    {
      name: '2',
      text: 'The Trump Administration’s Nuclear Posture Review calls for increased spending on US nuclear arsenal, suggests that nuclear weapons might be used in response to attacks of a non-nuclear nature, and brings back nuclear testing to the table if necessary for the advancement of the US nuclear arsenal. Do you find that this strategic document leads to a serious threat to the world peace?',
      latitude:38.897835, 
      longitude:-77.036549,
      images: [
        q2_1, q2_2, q2_3, q2_4, q2_5, q2_6, q2_7, q2_8, q2_9, q2_10
      ],
      yes: [
         'nuclear reduction', 'slashing defense budget', 'stabilizing international relations'
      ],
      no: [
        'boosting defense budget', 'nuclear testing resurgence', 'rising global tensions', 'nuclear proliferation'
      ]
    },
    {
      name: '3',
      text: 'Historically, there have been three major nuclear arms control treaties: the ABM (Anti-Ballistic Missile) Treaty; the INF (Intermediate-range Nuclear Forces) Treaty and the New START (Strategic Arms Reduction) Treaty. In 2002 the US withdrew from the ABM, leading to its termination. In August 2019, US has also withdrawn from INF treaty, accusing Russia of non-compliance. The new START treaty which comes up for renewal in 2020 has already been denounced by the Trump Administration. Do you think in the absence of these treaties we are one step closer to the actual use of nuclear weapons?',
      latitude:50.091059, 
      longitude:14.400476,
      images: [
        q3_1, q3_2, q3_3, q3_4, q3_5, q3_6, q3_7, q3_8, q3_9, q3_10
      ],
      yes: [
         'diplomatic negotiation', 'nuclear reduction', 'stable political climate'
      ],
      no: [
        'nuclear proliferation', 'military-industrial complex', 'hostile political climate'
      ]
    },
    {  //not working
      name: '4',
      text: ' Barak Obama rode into office in 2009 with promises to work toward a nuclear-free world and his vow helped win him the Nobel Peace Prize that year. Within a year, he confirmed that the US would in fact retain its nuclear arsenal but would not develop any new types. However, in his final budget request to Congress in 2016, he went on to authorize a nuclear modernization program of 1.2 billion dollars. Do you think maintaining and modernizing nuclear arsenals contribute to a safer global environment?',
      latitude:38.890231, 
      longitude:-77.009029,
      images: [
        q4_1, q4_2, q4_3, q4_4, q4_5, q4_6, q4_7, q4_8, q4_9, q4_10
      ],
      yes: [
         'rising global tension', 'nuclear proliferation', 'military-industrial complex', 'misuse of taxpayer money'
      ],
      no: [
        'nuclear reduction', 'decreasing global tension', 'reallocating public funds'
      ]
    },
    {
     name: '5',
     text: 'Globally, annual expenditure on nuclear weapons is estimated at $105 billion – or $12 million an hour. Given this hefty financial investment, do you think maintenance and modernization of nuclear forces divert vast public resources away from vital services such as health care, education, climate change mitigation, disaster relief and development assistance among others?',
     latitude:41.6643,
     longitude:-65.9385,
     images: [
      q5_1, q5_2, q5_3, q5_4, q5_5, q5_6, q5_7, q5_8, q5_9, q5_10
     ],
     yes: [
        'accessibility of public resources', 'equitable redistribution of funds', 'increased spending on vital services'
     ],
     no: [
       'public funding deprivation', 'military overspending', 'disproportionate defense budget'
     ]     
    }, 
    {
      name: '6',
      text: 'US and Russia collectively own more than 90 percent of the world’s nuclear weapons, 1800 of which are currently set on high-alert status. The technical and administrative controls governing nuclear weapons have been designed by human beings—and therefore remain imperfect. Do you think the danger of accidents, mistakes, false alarms, blackmail, theft, terrorism, unauthorized launch and sabotage make it a rational decision for these weapons not to be on set on launch-ready mode?',
      latitude:47.721631, 
      longitude:-122.715887,
      images: [
        q6_1, q6_2, q6_3, q6_4, q6_5, q6_6, q6_7, q6_8, q6_9, q6_10
      ],
      yes: [
         'preserving public security', 'safe management of nukes', 'multi-polar power structure', 'political reconciliation'
      ],
      no: [
        'endangering public security', 'nuclear arms race', 'sustaining bipolar power structure', 'nukes as currency of power', 'widening the political divide'
      ]      
    }, 
    { 
      name: '7',
      text: 'Belgium, Germany, Italy, Netherlands and Turkey host American nuclear weapons as part of NATO Nuclear Sharing Arrangements and others like Canada and Australia contribute to nuclear cycle by uranium mining while endorsing and relying on the US arsenal for their security. Do you think this level of participation endangers the global safety and security environment even further than the threat of the existing 9 nuclear states?',
      latitude:50.877837, 
      longitude:4.427273,
      images: [
        q7_1, q7_2, q7_3, q7_4, q7_5, q7_6, q7_7, q7_8, q7_9, q7_10
      ],
      yes: [
         'restricting NATO aggressive militarism', 'nuclear containment', 'inhibiting hostile global climate'
      ],
      no: [
        'nuclear contagion', 'endorsing NATO militarism', 'igniting hostile global climate'
      ]   
    },
    {
      name: '8',
      text: 'Creating a Weapon of Mass Destruction Free Zone in the Middle East is a guaranteed strategy to close the case of Iran potentially developing nuclear weapons and hence resolves the global crisis over the lost Iran Deal, the aftermath of which is threatening the global peace and security after the Trump administration pulled out of the mutually agreed deal. Considering that the US and the UK have a special commitment to develop such a zone in the region under the UN Security Council Resolution 687, do you think establishing such a zone in the Middle East should be a priority for the international community?',
      latitude:35.5203321,
      longitude:48.9016797,
      images: [
        q8_1, q8_2, q8_3, q8_4, q8_5, q8_6, q8_7, q8_8, q8_9, q8_10
      ],
      yes: [
         'WMD-free Middle East', 'stabilizing the region', 'peace building in the Middle East'
         
      ],
      no: [
        'global crisis', 'growing conflict in the region', 'war-mongering in the Middle East','threatening the world peace'
      ] 
    },
    { 
      name: '9',
      text: 'Taking the case of North Korea into account, which succeeded in developing its nuclear arsenal despite countless rounds of economic sanctions and UN Security Council Resolutions, some analysts believe that putting economic sanction on Iran not only will fail to resolve its case but given the geopolitics of the Middle East and historical animosity between Iran and the US will instead escalate the tensions into a major war. Do you agree with this statement?',
      latitude:39.797654,
      longitude:125.754880,
      images: [
        q9_1, q9_2, q9_3, q9_4, q9_5, q9_6, q9_7, q9_8, q9_9, q9_10
      ],
      yes: [
         'resolving historical animosity', 'developing positive relationships', 'establishing peace in the region', 'diplomatic resolution'
      ],
      no: [
        'another war in the Middle East', 'crippling economic sanctions', 'deepening historical animosity', 
        'igniting conflict in the region'
      ]
    }, 
    {
      name: '10',
      text: 'The Treaty on the Prohibition of Nuclear Weapons is the first legally binding international agreement to comprehensively ban, prohibit and eliminate nuclear weapons, currently signed by 70 countries as of 2017. Most Nuclear States including US and Russia boycotted the talks even though those abiding by NPT are bound by the Article 6 to negotiate in good faith for the elimination of the nuclear weapons. Do you think Nuclear States should endorse their disarmament commitments under the NPT?',
      latitude:40.749128, 
      longitude:-73.967966,
      images: [
        q10_1, q10_2, q10_3, q10_4, q10_5, q10_6, q10_7, q10_8, q10_9, q10_10
      ],
      yes: [
         'working towards disarmament', 'promoting peace', 'nuclear reduction', 'diplomacy over defense'
      ],
      no: [
        'discounting NPT commitments', 'contributing to global arms race', 'exercising veto power', 
        'maximizing military capabilities'
      ]
    },
    {
      name: '11',
      text: 'In 2017, the Union of Concerned Scientists, together with Physicians for Social Responsibility, launched Back from the Brink: The Call to Prevent Nuclear War, a national grassroots initiative that calls the US to lead a global effort by: renouncing the first use policy; ending the sole presidential authority to launch a nuclear attack; taking the weapons off hair-trigger alert; cancelling the nuclear modernization program; and actively pursuing global disarmament agreements. Would you support such a cause?',
      latitude:42.373655, 
      longitude:-71.121936,
      images: [
        q11_1, q11_2, q11_3, q11_4, q11_5, q11_6, q11_7, q11_8, q11_9, q11_10
      ],
      yes: [
         'mitigating nuclear arms race', 'renouncing the first use policy', 'taking the weapons off hair-trigger alert', 
         'ending the sole presidential authority', 'cancelling the nuclear modernization program', 
         'actively pursuing global disarmament agreements'
      ],
      no: [
        'assenting to presidential sole authority', 'confrontational diplomacy', 
        'maintaining the nuclear modernization program', 'adhering to first use policy', 
        'terminating the global disarmament agreements'
      ]
    },
    {
      name: '12',
      text: 'Every year since 1947, Bulletin of the Atomic Scientist publish a doomsday clock, signifying how close we are to midnight, i.e. a man-made global catastrophe. Their 2020 edition sets the time to 100 seconds, the closest it has ever been to midnight. In their statement two familiar global threats are mentioned: nuclear and climate security, and a third alarming threat: international erosion of political infrastructure. Do you find this last threat to be specifically alarming?',
      latitude: 41.785502, 
      longitude:-87.596825,
      images: [
        q12_1, q12_2, q12_3, q12_4, q12_5, q12_6, q12_7, q12_8, q12_9, q12_10
      ],
      yes: [
         'political engagement', 'promoting democracy', 'climate mitigation', 'nuclear safety advocacy'
      ],
      no: [
        'political paralysis', 'undermining democracy', 'authoritarian capitalism', 'ignoring climate change',
        'nuclear catastrophe'
      ]
    }
  ]